import type { Fields } from "@smartsuite/smartsuite-client";
import { ValueDescription_T } from "@smartsuite/automation-engine-api";

export const ssFields: Fields[] = [
  "firstcreatedfield",
  "lastupdatedfield",
  "userfield",
  "linkedrecordfield",
  "teamfield",
];

export const ssTypes: ValueDescription_T[] = [ValueDescription_T.STRING];

export const generalTypes: ValueDescription_T[] = [ValueDescription_T.STRING];
